import { Autocomplete, TextField } from "@mui/material";

export default function InfiniteAutocomplete(props) {
    const {
        options,
        onScroll,
        onChange,
        inputValue,
        setInputValue,
        total_options,
        value,
        helperText,
        error,
        onBlur,
    } = props;

    return (
        <>
            <Autocomplete
                value={value}
                onInputChange={setInputValue}
                autoHighlight
                options={options}
                onChange={onChange}
                getOptionLabel={(option) => option.name}
                getOptionKey={(option) => `${option.id}-${option.name}`}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onBlur={onBlur}
                        label={total_options}
                        value={inputValue}
                        helperText={helperText}
                        error={error}
                    />
                )}
                ListboxProps={{
                    onScroll: onScroll,
                    style: { maxHeight: 300, overflow: "auto" },
                }}
            />
        </>
    );
}
